import React from "react";

// Swiper
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import PlaceHolderUser from "assets/images/Useravatar.svg";
// Styles
import "swiper/css";

export default function NewCustomSlider({ data }) {
  const settings = data?.settings ||  {
    slidesPerView: 3,
    spaceBetween: 20,
    breakpoints: {
      0:    { slidesPerView: 1 },
      768:  { slidesPerView: 2 },
      1024: { slidesPerView: 3 },
    }
  };
  // Honour either slidesPerView (Swiper) or slidesToShow (legacy slick) from caller.
  const slidesPerView = settings.slidesPerView ?? settings.slidesToShow ?? 3.5;
  // When the caller picks an explicit count, let the slide size to the container.
  // Falling back to the historical 500px keeps existing call sites looking the same.
  const slideStyle = settings.slidesPerView != null || settings.slidesToShow != null
    ? undefined
    : { width: "500px" };

  return (
    <div className="custom-slider-section slider-dot-arrow">
      <div className="slider-bleed-wrapper">
        <Swiper
          modules={[Autoplay]}
          loop={true}
          slidesPerView={slidesPerView}
          spaceBetween={settings.spaceBetween ?? 20}
          speed={500}
          breakpoints={settings.breakpoints}
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          }}
          className="py-3"
        >
          {data.items?.map((item, i) => (
            <SwiperSlide
              key={item.id || i}
              style={slideStyle}
            >
              <div className="testimonial-card d-flex flex-column h-100">
                {/* DESCRIPTION */}
                <p className="testimonial-text">{item.description}</p>

                {/* USER */}
                <div className="testimonial-user d-flex align-items-center mt-auto">
                  <div className="user-img">
                    <img src={item.image} alt={item.name} />
                  </div>

                  <div className="user-info">
                    <h5 className="user-name">{item.name}</h5>
                    <p className="user-location">{item.location}</p>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
}
// import React from "react";
// import Slider from "react-slick";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";

// export default function NewCustomSlider({ data }) {
//   const defaultSettings = {
//     dots: false,
//     arrows: false,
//     infinite: true,
//     speed: 500,
//     // slidesToShow: 2.5,
//     centerMode: true,
//     centerPadding: "40px",
//     slidesToScroll: 1,
//     autoplay: true,
//     autoplaySpeed: 5000,
//     variableWidth: true,
//     responsive: [
//       {
//         breakpoint: 1200,
//         settings: { slidesToShow: 2 },
//       },
//       {
//         breakpoint: 991,
//         settings: { slidesToShow: 1 },
//       },
//       {
//         breakpoint: 575,
//         settings: { slidesToShow: 1 },
//       },
//     ],
//   };

//   const settings = { ...defaultSettings, ...data.settings };

//   return (
//     <div className="custom-slider-section slider-dot-arrow">
//       <div className="slider-bleed-wrapper">
//         <Slider {...settings}>
//           {data.items?.map((item, i) => (
//             <div key={item.id || i} className="" style={{width:'500px'}}>
//               <div className="testimonial-card">
//                 {/* DESCRIPTION */}
//                 <p className="testimonial-text">{item.description}</p>

//                 {/* USER */}
//                 <div className="testimonial-user d-flex align-items-center mt-3">
//                   <div className="user-img">
//                     <img src={item.image} alt={item.name} />
//                   </div>

//                   <div className="user-info">
//                     <h5 className="user-name">{item.name}</h5>
//                     <p className="user-location">{item.location}</p>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           ))}
//         </Slider>
//       </div>
//     </div>
//   );
// }
